import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import {
  PROPERTY_TYPE_OPTION_APARTMENT,
  PROPERTY_TYPE_OPTION_TOWNHOMES_DUPLEXES,
} from 'common/propertyTypes';
import {
  LEAD_TYPE_APARTMENT,
  getLeadType,
  isLowBudgetHomeLead,
  isUnreasonableApartmentLead,
} from 'common/leadTypeHelpers';
import {
  APT_LEAD_ASSIGNMENT_CONTEXT_FORCED_LOW_BUDGET,
  APT_LEAD_ASSIGNMENT_CONTEXT_OPT_IN_HIGH_BUDGET,
  APT_LEAD_ASSIGNMENT_DISPLAY_CONTEXT_SIGNUP,
} from 'common/leadConstants';
import { USER_ROLE_RENTER } from 'common/userRoles';
import { SCREEN_ID_SWITCH_TO_APARTMENTS } from 'client/constants/screenIds';

import SrSwitchToApartmentLowBudget from 'client/components/SrSwitchToApartmentLowBudget';
import UserActions from 'client/actions/User';
import ApartmentLocatorActions from 'client/actions/ApartmentLocator';
import branch from 'client/core/branch';
import allowedRoles from 'client/helpers/allowedRoles';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withScreenId from 'client/helpers/withScreenId';

@withTransitionHook
@allowedRoles({
  roles: [USER_ROLE_RENTER],
  redirectUrl: '/start',
})
@withScreenId(SCREEN_ID_SWITCH_TO_APARTMENTS)
@withScrollToTop
@branch({
  currentUser: ['currentUser'],
})
class SwitchToApartments extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  _onSwitchToApartments = (isLowBudget) => {
    const { dispatch, currentUser, history } = this.props;

    const wasUnreasonableApartmentLead = isUnreasonableApartmentLead(currentUser);

    const newSearchFilters = {
      ...currentUser.searchFilters,
      propertyTypes: [PROPERTY_TYPE_OPTION_APARTMENT, PROPERTY_TYPE_OPTION_TOWNHOMES_DUPLEXES],
    };

    const newLeadType = getLeadType({ ...currentUser, searchFilters: newSearchFilters });

    dispatch(UserActions.update, {
      leadType: newLeadType,
      searchFilters: newSearchFilters,
    })
      .then(() => {
        if (newLeadType === LEAD_TYPE_APARTMENT && !wasUnreasonableApartmentLead) {
          return dispatch(ApartmentLocatorActions.assignLeadApartmentLocator, {
            userId: currentUser.id,
            assignmentContext: isLowBudget
              ? APT_LEAD_ASSIGNMENT_CONTEXT_FORCED_LOW_BUDGET
              : APT_LEAD_ASSIGNMENT_CONTEXT_OPT_IN_HIGH_BUDGET,
            displayContext: APT_LEAD_ASSIGNMENT_DISPLAY_CONTEXT_SIGNUP,
            enableSmsMessage: true,
            canOverwrite: false,
          });
        }
      })
      .then(() => {
        history.push('/feed');
      });
  };

  render() {
    const { currentUser } = this.props;

    // Switched from Home Lead (Low Budget):
    // The user signed up with low budget, but is still "reasonable", we force them
    // to work with an apartment locator.
    if (isLowBudgetHomeLead(currentUser)) {
      return (
        <SrSwitchToApartmentLowBudget
          onAccept={() => this._onSwitchToApartments(true)}
          currentUser={currentUser}
        />
      );
    }

    // The user has a completely unreasonable budget and therefore they should not be
    // assigned to anybody. Direct them to the explore page.
    return <Redirect to="/feed" />;
  }
}

export default SwitchToApartments;
